import { render, staticRenderFns } from "./ModuleStudentListSlidebar.vue?vue&type=template&id=11fe0c75"
import script from "./ModuleStudentListSlidebar.vue?vue&type=script&lang=js"
export * from "./ModuleStudentListSlidebar.vue?vue&type=script&lang=js"
import style0 from "./ModuleStudentListSlidebar.vue?vue&type=style&index=0&id=11fe0c75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports